import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import SectionHeader from '../SectionHeader';

import './styles';

export default class FlatRateSection extends React.Component {
  productDescription(product, key) {
    if (product.content.length > 1) {
      return (
        <div className="content">
          {_.map(product.content, (item, index) => (
            <p key={key + index} className="description">{item.description}
              <span className="price float right primary-color">{item.price}</span></p>
          ))}
        </div>
      );
    }
    const item = product.content[0];
    return (
      <div className="content">
        <p className="description">{item.description}</p>
        <h2 className="price primary-color">{item.price}</h2>
      </div>
    );
  }

  render() {
    const { titleText, titleDescription, products, shipping, shippingTitle, shippingDescription, pageType } = this.props;

    const shippingCard = _.map(shipping, (info, index) => (
      <div key={index} className="column">
        <div className="shipping-card ui padded segment">
          <h2 className="card-title"><i className={info.iconClass} />{info.title}</h2>
          <h3 className="header-1 primary-color">Domestic shipping</h3>
          <h3 className="desc-1 primary-color">
            <span className="price">{info.domestic.price}&nbsp;</span>
            <span>{info.domestic.detail}</span>
          </h3>
          <h4 className="header-2 secondary-color">International shipping</h4>
          <h4 className="desc-2 secondary-color">
            <span className="price">{info.international.price}&nbsp;</span>
            <span>{info.international.detail}</span>
          </h4>

        </div>
      </div>
    ));

    return (
      <div className={classnames('FlatRate', pageType)}>
        <div className=" ui container p-b-4">
          <SectionHeader titleText={titleText} titleDescription={titleDescription} />
          <div className="product-grid ui four column doubling grid p-b-4">
            {_.map(products, (product, index) => (
              <div key={index} className="column">
                <img className="ui fluid image" src={require(`../../assets/${product.image}`)} />
                <h4 className="name thick-text">{product.title}</h4>
                {this.productDescription(product, index)}
              </div>
            ))}
          </div>
          <div className="ui divider" />

          <SectionHeader titleText={shippingTitle} titleDescription={shippingDescription} />
          <div className="ui two column stackable grid">
            {shippingCard}
          </div>
        </div>
        <div className="ui divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/FlatRateSection/index.jsx